import PropTypes from "prop-types";
//Limitless imports
import { log as pilog } from "@limitless/common/utils";
import { useExpertMessageFlagContext } from "../../../hooks/expert-message-flag/ExpertMessageFlagContext";
import { validateMessageFlagFormValidator } from "../../../utils/validators/MessageFlagFormValidator";
const FLAG_TYPES = {
  report: {
    overlayTitle: "Report back to Limitless",
    inputPlaceholder: "Reason for reporting",
    reasonCodeName: "report",
    dropdownPlaceholder: "Reason for reporting this conversation",
    disabledTooltip: "You must select a reason before this conversation can be reported"
  },
  escalation: {
    overlayTitle: "Forward back to client",
    inputPlaceholder: "Reason for forwarding",
    reasonCodeName: "escalation",
    dropdownPlaceholder: "Reason for forwarding this conversation",
    disabledTooltip: "You must select a reason before this conversation can be forwarded"
  }
};
const MessageFlagForm = ({
  children,
  type,
  onSubmitFlagData
}) => {
  const {
    messageFlag,
    setMessageFlagDetails,
    sendMessageFlag,
    messageResources
  } = useExpertMessageFlagContext();
  const log = pilog.getLogger("MessageFlagForm");
  const onFormSubmit = () => {
    if (onSubmitFlagData) {
      onSubmitFlagData();
    } else {
      sendMessageFlag(type);
    }
  };
  const handleBodyChange = value => {
    const newValue = {
      value,
      pristine: false
    };
    setMessageFlagDetails(type, {
      body: newValue
    });
  };
  const handleCodeChange = value => {
    log.debug({
      value
    });
    value.pristine = false;
    setMessageFlagDetails(type, {
      code: value
    });
  };
  const {
    fieldErrors,
    isFormInvalid
  } = validateMessageFlagFormValidator(messageFlag[type]);
  const flagAction = FLAG_TYPES[type];
  const codeList = messageResources.reasonCodes.codes[flagAction.reasonCodeName];
  return children({
    code: messageFlag[type].code,
    body: messageFlag[type].body,
    codeList,
    flagAction,
    fieldErrors,
    onCodeChange: handleCodeChange,
    onBodyChange: handleBodyChange,
    onFormSubmit,
    isFormInvalid
  });
};
export default MessageFlagForm;
MessageFlagForm.propTypes = {
  children: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired
};